import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";
import { useLang } from "@/context/LanguageContext";
import { Cookie } from "lucide-react";

const CookieConsent = ({ show, setShow }) => {
  const { t } = useLang();
  if (!show) return null;
  const choose = (v) => { localStorage.setItem("sp_cookie_choice", v); setShow(false); };
  return (
    <div data-testid="cookie-consent" className="fixed bottom-4 left-4 right-4 sm:left-auto sm:max-w-md z-[1100] bg-[#181A20] border border-amber-800/40 rounded-lg p-5 shadow-[0_10px_40px_rgba(0,0,0,0.8)]">
      <div className="flex items-center gap-2 mb-2">
        <Cookie className="w-4 h-4 text-amber-500" />
        <span className="font-serif text-base text-amber-100">{t("cookie_title")}</span>
      </div>
      <p className="text-sm text-stone-300 mb-4">
        {t("cookie_msg")}{" "}
        <Link to="/legal/cookies" data-testid="cookie-learn-link" className="text-amber-400 hover:text-amber-300 underline underline-offset-2">{t("cookie_link")}</Link>
      </p>
      <div className="flex items-center gap-2">
        <button
          data-testid="cookie-accept-btn"
          onClick={() => choose("accepted")}
          className="bg-amber-600 hover:bg-amber-500 text-stone-950 font-semibold px-5 py-2 rounded-md text-sm transition-colors"
        >
          {t("cookie_accept")}
        </button>
        <button
          data-testid="cookie-refuse-btn"
          onClick={() => choose("refused")}
          className="bg-transparent hover:bg-[#22252D] text-stone-300 font-medium px-5 py-2 rounded-md text-sm border border-[#272A34] hover:border-amber-500/40 transition-all"
        >
          {t("cookie_refuse")}
        </button>
      </div>
    </div>
  );
};

export const Layout = ({ children }) => {
  const [cookieShow, setCookieShow] = useState(false);
  useEffect(() => {
    setCookieShow(!localStorage.getItem("sp_cookie_choice"));
  }, []);
  return (
    <div className="min-h-screen flex flex-col bg-[#0B0C0E]">
      <Header />
      <main className={`flex-1 pt-20 ${cookieShow ? "pb-44 sm:pb-28" : ""}`}>{children}</main>
      <Footer />
      <CookieConsent show={cookieShow} setShow={setCookieShow} />
      <CartDrawer />
    </div>
  );
};

export default Layout;
